import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import FalconCloseButton from '../../components/common/FalconCloseButton';
import '../../styles/calendar.css';
import ProfileBanner from './Banner';
import TeamVacationsCalendar from './TeamVacationsCalendar';
import VacationSection from './VacationSection';

const Profile = () => {
    //Parametros
    const { id } = useParams();
    const { showErrorToast, showSuccessToast } = useToast();
    const { token, setToken, idUsuario, idCatTipoUsuario, setProfileImage } = useToken();
    const [cargando, setCargando] = useState(true);
    const [procesandoModal, setProcesandoModal] = useState(false);
    const [dataForm, setDataForm] = useState({});
    const [perfil, setPerfil] = useState([]);
    const [showModalFoto, setShowModalFoto] = useState(false);
    const [imagenPerfil, setImagenPerfil] = useState("");

    /**
    * Retorna la información para mostrar
    */
    const obtenerPerfil = async () => {

        const response = await fetch("/api/perfil/obtenerDatosPerfil/?id=" + (!id ? idUsuario : id),
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {

            console.log("==== OBTENER INFORMACION DEL PERFIL ====");
            console.log(response);
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                console.log(detalles);

                setPerfil(detalles['table2'][0]);

            } else {

                showErrorToast(data.vMessage);
            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
    };

    /* Retorna la imagen de perfil */
    const obtenerImagenPerfil = async () => {

        const response = await fetch("/api/perfil/obtenerImagenPerfil/?idUsuario=" + (!id ? idUsuario : id),
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'text/plain'
                }
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {

            console.log("==== OBTENER IMAGEN DEL PERFIL ====");
            console.log(response);
            const data = await response.text();
            console.log(response);
            setImagenPerfil(data)

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
    };

    //Enviar Datos Para Marcar Pagada
    const onSubmitCargarFoto = async () => {

        if (dataForm.vArchivo.size > 3000 * 1024) { // Tamaño máximo: 40KB
            alert("El archivo es demasiado grande. Debe ser menor a 40KB");
            return;
        }

        if (!["image/jpeg"].includes(dataForm.vArchivo.type)) { // Solo imágenes JPG
            alert("Solo se permiten archivos JPG");
            return;
        }


        setProcesandoModal(true);
        var data = new FormData()
        data.append('FormFile', dataForm.vArchivo);

        const response = await fetch("/api/perfil/cargarfoto", {
            method: 'POST',
            body: data,
            headers:
            {
                'Authorization': 'Bearer ' + token
            }
        }).catch((error) => {

            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data.iResponseType == 1) {
                setProfileImage(data.detalles);
                showSuccessToast(data.vMessage);
            } else {

                showErrorToast(data.vMessage);
            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setProcesandoModal(false);
        setShowModalFoto(false);
    };

    useEffect(() => {
        obtenerPerfil();
        obtenerImagenPerfil();
    }, [id]);

    return (
        <>
            {cargando ?
                (<h5><Spinner className="text-inline mt-3" animation="border" variant="primary" /> Cargando...</h5>)
                :
                <>
                    <ProfileBanner perfil={perfil} setShowModalFoto={setShowModalFoto} imagenPerfil={imagenPerfil} />

                    {/* Sección de vacaciones personales - Solo visible para el usuario de la sesión */}
                    {(!id || id === idUsuario.toString() || idCatTipoUsuario == "1") && (
                        <VacationSection
                            perfil={perfil}
                        />
                    )}

                    {/* Calendario de vacaciones del equipo */}
                    <TeamVacationsCalendar token={token} />

                </>
            }

            {/* Modal para subir foto */}
            <Modal
                show={showModalFoto}
                onHide={() => setShowModalFoto(false)}
                size="md"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title>Cambiar foto</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalFoto(false); }} />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Adjuntar fotograf&iacute;a</Form.Label>
                        <Form.Control
                            type="file"
                            size="sm"
                            required
                            onChange={(e) => setDataForm({
                                ...dataForm,
                                vArchivo: e.target.files[0],
                                vNombreDocumento: e.target.files[0].name,
                                vTipoDocumento: e.target.files[0].type,
                                vTamano: e.target.files[0].size
                            })}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalFoto(false) }} variant='primary' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="button" onClick={() => onSubmitCargarFoto()} variant='success' >Cambiar Foto</Button>}
                </Modal.Footer>

            </Modal>
        </>

    );
};

export default Profile;
